import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { getCategories, countByCategory } from "@/lib/content";

export default function CategoryGrid() {
  const categories = getCategories();

  return (
    <section id="categories" className="bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-8xl">
        <SectionHeading
          eyebrow="主题分类"
          title="六条内容线，覆盖你关心的话题类型"
          description="从事件全记录到行业透视，每一份档案都会被归入对应方向，方便你按兴趣连续阅读，也方便检索与引用。"
        />

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/topics?category=${cat.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xl text-accent-800 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={cat.icon} />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {cat.name}
                  </h3>
                  <span className="shrink-0 text-xs text-foreground-400">
                    {countByCategory(cat.id)} 份
                  </span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}